import * as React from "react";
import {
    BlindsStructure, Payout, PayoutStructure, SitAndGoConfig, TimeZone, TournamentConstraints,
    TournamentOperator
} from "../../../../../generated/protocol";
import {
    TOURNAMENT_CONSTRAINTS_SERVICE_NAME,
    TournamentConstraintsService
} from "../../../../service/poker/tournament/TournamentConstraintsService";
import {AppCtx} from "../../../../ioc/ApplicationContext";
import {LoadingViewState, RouterView} from "../../RouterView";
import {FormListener} from "../../../form/Form";
import {SitAndGoService} from "../../../../service/poker/tournament/SitAndGoService";
import {Symbols} from "../../../../ioc/Symbols";
import {SitAndGoForm} from "../../../poker/tournament/SitAndGoForm";
import {BlindsStructureService} from "../../../../service/poker/tournament/BlindsStructureService";
import {BlindsStructureForm} from "../../../poker/tournament/BlindsStructureForm";
import {PayoutStructureService} from "../../../../service/poker/tournament/PayoutStructureService";
import {PayoutStructureForm} from "../../../poker/tournament/PayoutStructureForm";


interface State extends LoadingViewState {
    structure?: PayoutStructure;
    validationMap?: any;
    errorMessage?: string;
    success?: boolean;
    inProgress?: boolean;
}

const createInitialState = () => {
    return {
        validationMap: {},
        structure: {
            blindsLevels: [
                {}
            ]
        }
    }
};

interface Props {
    params: { id: string, copyTemplate?: string }
}

export class PayoutStructureView extends RouterView<Props, State> implements FormListener<PayoutStructure> {

    service: PayoutStructureService;

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, createInitialState());
        this.service = AppCtx.resolve<PayoutStructureService>(Symbols.PayoutStructureService);
    }

    componentDidUpdate(prevProps: Props, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.refreshContent();
            return;
        }
        super.componentDidUpdate(prevProps, prevState);
    }

    onSaveConfirmed() {
        this.navigate("/tournament-structures/payout/" + this.state.structure.id);
    }


    loadContent(): Promise<any> {
        if (this.props.params.id == "new") {
            if (this.props.params.copyTemplate) {
                return this.service.getEntity(this.props.params.copyTemplate).then((bs: PayoutStructure) => {
                    bs.payoutsPerEntryRange.forEach(l => {
                        l.id = null;
                        l.payoutList.forEach(p => p.id = null);
                    });
                    bs.id = null;
                    bs.name = bs.name + " Copy";
                    this.setState({structure: bs});
                });
            } else {
                return Promise.resolve();
            }
        } else {
            return Promise.all<any>([
                this.service.getEntity(this.props.params.id),
            ]).then(results => {
                this.setState({structure: results[0]});
            });
        }

    }

    onSubmit(): Promise<any> {
        return this.service.save(this.state.structure).then((t: BlindsStructure) => {
            this.setState({structure: t});
        }).catch(err => {
            console.log("ERROR = ", err);
            throw err.message;
        });
    }

    onSubmitError() {
        console.log("State on error = ", this.state.structure);
    }

    formDidUpdate(formModel: PayoutStructure, validationMap: any) {
        this.setState({structure: formModel, validationMap: validationMap});
    }

    getTitle(): string {
        return "Payout Structure";
    }

    renderContent() {

        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <PayoutStructureForm
                        validationMap={this.state.validationMap}
                        formListener={this}
                        structure={this.state.structure}
                        onSuccessClose={this.onSaveConfirmed.bind(this)}/>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/view/poker/tournament/PayoutStructureView.tsx